<div class="app-menu__loader" *ngIf="isLoading">
  <app-loading [onlyIcon]="true"></app-loading>
  {{ 'COMMONS.LOADING' | i18nextEager }}
</div>
<aside>
  <div class="app-menu" [ngClass]="{ 'app-menu--open': open }">
    <div class="app-menu__container">
      <div
        routerLink="{{ '/home' + suffixComponent }}"
        routerLinkActive="active"
        #home="routerLinkActive"
        class="app-menu__container__link"
      >
        <div class="app-menu__container__link__left flex-end">
          <span class="app-menu__container__icon" [ngClass]="{ 'app-menu__container__icon--open': open }">
            <img src="/assets/icons/home.svg" alt="" />
          </span>
          <span class="show">{{ 'BREADCRUMBS.HOME' | i18nextEager }}</span>
        </div>
      </div>
      <div
        routerLink="/customers"
        routerLinkActive="active"
        #customers="routerLinkActive"
        class="app-menu__container__link"
      >
        <div class="app-menu__container__link__left flex-end">
          <span class="app-menu__container__icon" [ngClass]="{ 'app-menu__container__icon--open': open }">
            <img src="/assets/icons/clients.svg" alt="" />
          </span>
          <span class="show">{{ 'BREADCRUMBS.CUSTOMERS' | i18nextEager }}</span>
        </div>
      </div>
      <div
        *ngIf="isUserSpanish"
        routerLink="/contracts"
        routerLinkActive="active"
        #customers="routerLinkActive"
        class="app-menu__container__link"
      >
        <div class="app-menu__container__link__left flex-end">
          <span class="app-menu__container__icon" [ngClass]="{ 'app-menu__container__icon--open': open }">
            <img src="/assets/icons/contracts.svg" alt="" />
          </span>
          <span class="show">{{ 'BREADCRUMBS.CONTRACTS' | i18nextEager }}</span>
        </div>
      </div>
      <div
        routerLink="/tracing"
        routerLinkActive="active"
        #tracing="routerLinkActive"
        class="app-menu__container__link"
      >
        <div class="app-menu__container__link__left flex-end">
          <span class="app-menu__container__icon" [ngClass]="{ 'app-menu__container__icon--open': open }">
            <img src="/assets/icons/route.svg" alt="" />
          </span>
          <span class="show">{{ 'BREADCRUMBS.TRACING' | i18nextEager }}</span>
        </div>
      </div>
      <div
        routerLink="/campaigns"
        routerLinkActive="active"
        #campaigns="routerLinkActive"
        class="app-menu__container__link"
      >
        <div class="app-menu__container__link__left flex-end">
          <span class="app-menu__container__icon" [ngClass]="{ 'app-menu__container__icon--open': open }">
            <img src="/assets/icons/campaign.svg" alt="" />
          </span>
          <span class="show">{{ 'BREADCRUMBS.CAMPAIGNS' | i18nextEager }}</span>
        </div>
      </div>
      <div
        *ngIf="isUserSpanish"
        routerLink="/incidents"
        routerLinkActive="active"
        #incidents="routerLinkActive"
        class="app-menu__container__link"
      >
        <div *ngIf="casesNotifications > 0" class="notification-warn">{{ casesNotifications }}</div>
        <div class="app-menu__container__link__left flex-end">
          <span class="app-menu__container__icon" [ngClass]="{ 'app-menu__container__icon--open': open }">
            <img src="/assets/icons/fire.svg" alt="" />
          </span>
          <span class="show">{{ 'BREADCRUMBS.INCIDENTS' | i18nextEager }}</span>
        </div>
      </div>
      <div
        routerLink="/resources"
        routerLinkActive="active"
        #resources="routerLinkActive"
        class="app-menu__container__link"
      >
        <div class="app-menu__container__link__left flex-end">
          <span class="app-menu__container__icon" [ngClass]="{ 'app-menu__container__icon--open': open }">
            <img src="/assets/icons/resources.svg" alt="" />
          </span>
          <span class="show">{{ 'BREADCRUMBS.RESOURCES' | i18nextEager }}</span>
        </div>
      </div>
      <div
        *ngIf="isConsultaSips && isUserSpanish"
        routerLink="/sipsdata"
        routerLinkActive="active"
        #resources="routerLinkActive"
        class="app-menu__container__link"
      >
        <div class="app-menu__container__link__left flex-end">
          <span class="app-menu__container__icon" [ngClass]="{ 'app-menu__container__icon--open': open }">
            <img class="icon-sips" src="/assets/icons/sips-data.png" alt="" />
          </span>
          <span class="show">{{ 'BREADCRUMBS.SIPS_DATA' | i18nextEager }}</span>
        </div>
      </div>
      <!-- <div
        *ngIf="!isExternal"
        routerLink="/simulations"
        routerLinkActive="active"
        #resources="routerLinkActive"
        class="app-menu__container__link"
      >
        <div class="app-menu__container__link__left flex-end">
          <span class="app-menu__container__icon" [ngClass]="{ 'app-menu__container__icon--open': open }">
            <img src="/assets/icons/simulations.svg" alt="{{ 'BREADCRUMBS.SIMULATIONS' | i18nextEager }}" />
          </span>
          <span class="show">{{ 'BREADCRUMBS.SIMULATIONS' | i18nextEager }}</span>
        </div>
      </div> -->
      <!-- <div class="app-menu__container__link" (click)="navigateSap()">
        <div class="app-menu__container__link__left flex-end">
          <span class="app-menu__container__icon" [ngClass]="{ 'app-menu__container__icon--open': open }">
            <img src="/assets/icons/leaderboard.svg" alt="{{ 'BREADCRUMBS.SAP' | i18nextEager }}" />
          </span>
          <span class="show">{{ 'BREADCRUMBS.SAP' | i18nextEager }}</span>
        </div>
      </div> -->
      <!-- <div
      *ngIf="isUserSpanish"
        routerLink="/co2"
        routerLinkActive="active"
        #co2="routerLinkActive"
        class="app-menu__container__link"
      >
        <div class="app-menu__container__link__left flex-end">
          <span class="app-menu__container__icon" [ngClass]="{ 'app-menu__container__icon--open': open }">
            <img src="/assets/icons/co2.svg" alt="" />
          </span>
          <span class="show">{{ 'BREADCRUMBS.CO2' | i18nextEager }}</span>
        </div>
      </div> -->
    </div>
  </div>
</aside>
